import { EventEmitter, OnInit, Output } from "@angular/core";
import { StepperItem } from "../stepper/app-stepper.component";

export abstract class WizardBaseComponent implements OnInit {
    
    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();
    
    currentStepNumber: number = 1;
    steps: StepperItem[] = [];

    ngOnInit(): void {
        this.initData();
    }

    abstract initData();

    abstract buildSteps();

    abstract saveStepChanges(afterAction: () => void);

    abstract saveChanges();

    moveToStep(step: StepperItem) {
        this.refreshStepStatuses();
        this.currentStepNumber = step.number;
    }

    goToPreviousStep() {
        this.refreshStepStatuses();
        if (this.isFirstStep) {
            this.close();
        }
        else {
            this.currentStepNumber -= 1;
        }
    }

    goToNextStep() {
        this.refreshStepStatuses();
        if (this.isLastStep) {
            this.saveChanges();
        }
        else {
            this.saveStepChanges(() => this.currentStepNumber += 1);
        }
    }

    refreshStepStatuses() {
        this.steps.forEach(x => x.isSuccess = x.checkSuccess());
    }

    close() {
        this.onCancelEvent.emit();
    }

    get canGoToNext(): boolean {
        let currentStep = this.steps.find(x => x.number == this.currentStepNumber);
        return currentStep.checkSuccess();
    }

    get currentStepId(): string {
        return this.steps.find(x => x.number == this.currentStepNumber).id;
    }

    get isLastStep(): boolean {
        return this.currentStepNumber == this.steps.length;
    }

    get isFirstStep(): boolean {
        return this.currentStepNumber == 1;
    }
}